export default "__VITE_ASSET__7aec4839__"